import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import useStore from '../../store';
import aaysLogo from '../../assets/Aays.png';
import aaysMark from '../../assets/Icons.png';
import { Icon } from '../icons';
import './Sidebar.css';

const NAV_CONFIG = {
  employee: [
    { section: 'Overview', items: [
      { path: '/dashboard', icon: 'squaresFour', label: 'Dashboard' },
      { path: '/attendance', icon: 'clock', label: 'My Attendance' },
      { path: '/leaves', icon: 'umbrella', label: 'My Leaves' },
      { path: '/holidays', icon: 'confetti', label: 'Holidays' },
    ]},
  ],
  manager: [
    { section: 'Overview', items: [
      { path: '/dashboard', icon: 'squaresFour', label: 'Dashboard' },
      { path: '/attendance', icon: 'clock', label: 'My Attendance' },
      { path: '/leaves', icon: 'umbrella', label: 'My Leaves' },
      { path: '/holidays', icon: 'confetti', label: 'Holidays' },
    ]},
    { section: 'Team', items: [
      { path: '/team/attendance', icon: 'users', label: 'Team Attendance' },
      { path: '/team/leaves', icon: 'checkCircle', label: 'Leave Approvals' },
      { path: '/team/overview', icon: 'chartPie', label: 'Team Overview' },
      { path: '/admin/verify-leave-balances', icon: 'clipboardText', label: 'Verify Balances' },
    ]},
  ],
  admin: [
    { section: 'Overview', items: [
      { path: '/dashboard', icon: 'squaresFour', label: 'Dashboard' },
      { path: '/attendance', icon: 'clock', label: 'My Attendance' },
      { path: '/leaves', icon: 'umbrella', label: 'My Leaves' },
      { path: '/holidays', icon: 'confetti', label: 'Holidays' },
    ]},
    { section: 'Team', items: [
      { path: '/team/attendance', icon: 'users', label: 'Team Attendance' },
      { path: '/team/leaves', icon: 'checkCircle', label: 'Leave Approvals' },
      { path: '/team/overview', icon: 'chartPie', label: 'Team Overview' },
      { path: '/admin/verify-leave-balances', icon: 'clipboardText', label: 'Verify Balances' },
    ]},
  ],
};

export default function Sidebar() {
  const { user, sidebarCollapsed, mobileNavOpen, closeMobileNav } = useStore();
  const role = user?.role || 'employee';
  const sections = NAV_CONFIG[role] || NAV_CONFIG.employee;

  // The desktop icon-rail collapse state is meaningless once the sidebar is
  // an off-canvas mobile drawer — always show full labels while it's open,
  // regardless of whatever collapse state was left over from a desktop view.
  const showLabels = !sidebarCollapsed || mobileNavOpen;

  // Lock background scroll while the mobile drawer is open.
  useEffect(() => {
    document.body.style.overflow = mobileNavOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileNavOpen]);

  return (
    <>
      {/* Backdrop: only rendered/visible as an overlay on mobile when the drawer is open */}
      <div
        className={`sidebar-backdrop ${mobileNavOpen ? 'sidebar-backdrop--visible' : ''}`}
        onClick={closeMobileNav}
        aria-hidden="true"
      />
      <aside className={`sidebar ${sidebarCollapsed && !mobileNavOpen ? 'sidebar--collapsed' : ''} ${mobileNavOpen ? 'sidebar--mobile-open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          {showLabels
            ? <img src={aaysLogo} alt="Aays" className="sidebar-logo-img" />
            : <img src={aaysMark} alt="Aays" className="sidebar-logo-mark-img" />}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {sections.map((section) => (
            <div key={section.section} className="sidebar-section">
              {showLabels && (
                <span className="sidebar-section-label">{section.section}</span>
              )}
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileNav}
                  className={({ isActive }) =>
                    `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`
                  }
                  title={!showLabels ? item.label : undefined}
                >
                  <span className="sidebar-link-icon"><Icon name={item.icon} size={18} /></span>
                  {showLabels && (
                    <span className="sidebar-link-label">{item.label}</span>
                  )}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
}
